import { ArrowBackIcon } from '@protector/icons';
import type { ButtonProps } from 'antd';
import { Button } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styles from './back-button.module.css';

type BackButtonProps = Omit<ButtonProps, 'type'> & { 'aria-label': string };

export const BackButton = (props: BackButtonProps) => (
  <Button
    type='text'
    classNames={{ root: styles.backButton }}
    icon={<ArrowBackIcon width={18} height={18} fill={COLOR_OPTIONS.NEUTRAL_60} />}
    {...props}
  />
);
